import script from "./actions-form.vue?vue&type=script&lang=ts&setup=true"
export * from "./actions-form.vue?vue&type=script&lang=ts&setup=true"

import "./actions-form.vue?vue&type=style&index=0&id=cc1ef13e&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc1ef13e"]])

export default __exports__